module.exports = __webpack_public_path__ + "img/2.a6df3690.jpg";